export default __webpack_public_path__ + "static/media/background-claim-gift.508a82a6.png";